// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
import { FIELD_TYPES } from "../../../../../../constants/template-field-type";
export default {
    card1ClientTitle: {
        type: FIELD_TYPES.TEXT,
        label: "Card 1 Client Title",
        translatable: true
    },
    card1Testimonial: {
        type: FIELD_TYPES.TEXT,
        label: "Card 1 Testimonial",
        translatable: true
    },
    card1Text: {
        type: FIELD_TYPES.TEXT,
        label: "Card 1 Text",
        translatable: true
    },
    card1Title: {
        type: FIELD_TYPES.TEXT,
        label: "Card 1 Title",
        translatable: true
    },
    card2ClientTitle: {
        type: FIELD_TYPES.TEXT,
        label: "Card 2 Client Title",
        translatable: true
    },
    card2Testimonial: {
        type: FIELD_TYPES.TEXT,
        label: "Card 2 Testimonial",
        translatable: true
    },
    card2Text: {
        type: FIELD_TYPES.TEXT,
        label: "Card 2 Text",
        translatable: true
    },
    card2Title: {
        type: FIELD_TYPES.TEXT,
        label: "Card 2 Title",
        translatable: true
    },
    card3ClientTitle: {
        type: FIELD_TYPES.TEXT,
        label: "Card 3 Client Title",
        translatable: true
    },
    card3Testimonial: {
        type: FIELD_TYPES.TEXT,
        label: "Card 3 Testimonial",
        translatable: true
    },
    card3Text: {
        type: FIELD_TYPES.TEXT,
        label: "Card 3 Text",
        translatable: true
    },
    card3Title: {
        type: FIELD_TYPES.TEXT,
        label: "Card 3 Title",
        translatable: true
    },
    stat1Subtitle: {
        type: FIELD_TYPES.TEXT,
        label: "Stat 1 Subtitle",
        translatable: true
    },
    stat1Text: {
        type: FIELD_TYPES.TEXT,
        label: "Stat 1 Text",
        translatable: true
    },
    stat2Subtitle: {
        type: FIELD_TYPES.TEXT,
        label: "Stat 2 Subtitle",
        translatable: true
    },
    stat2Text: {
        type: FIELD_TYPES.TEXT,
        label: "Stat 2 Text",
        translatable: true
    },
    stat3Subtitle: {
        type: FIELD_TYPES.TEXT,
        label: "Stat 3 Subtitle",
        translatable: true
    },
    stat3Text: {
        type: FIELD_TYPES.TEXT,
        label: "Stat 3 Text",
        translatable: true
    },
    title: {
        type: FIELD_TYPES.TEXT,
        label: "Title",
        translatable: true
    },
    customer1Headshot: {
        type: FIELD_TYPES.NESTED,
        label: "Customer 1 Headshot",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    customer1Logo: {
        type: FIELD_TYPES.NESTED,
        label: "Customer 1 Logo",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    customer2Headshot: {
        type: FIELD_TYPES.NESTED,
        label: "Customer 2 Headshot",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    customer2Logo: {
        type: FIELD_TYPES.NESTED,
        label: "Customer 2 Logo",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    customer3Headshot: {
        type: FIELD_TYPES.NESTED,
        label: "Customer 3 Headshot",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    customer3Logo: {
        type: FIELD_TYPES.NESTED,
        label: "Customer 3 Logo",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    }
};
